import React from 'react'
import { Button, ButtonStyle } from '../../../components/simple/button'
import { ControlledModal } from '../../../layouts/components/modal'

interface School {
  id: number
  name: string
  grades: string[]
}

export type SurveyData = {
  id: number
  name: string
  expiration_date?: string
  active: number
  school_id: number
  per_level: 'student' | 'recipient' | 'household' | 'link'
  json: string
  hasEnded: boolean
  defaultMessage: string
  anonymous: number
  school_name: string
  school: School | School[]
  creator_id: number
  sharedTeachers?: {
    id: number
    name: string
    email: string
  }[]
  creator_name: string
}

export const CloseIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="h-5 w-5"
    {...props}
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
)
export const ChevronRightIcon: React.FC<React.SVGProps<SVGSVGElement> & { isExpanded?: boolean }> = ({
  isExpanded,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`h-5 w-5 text-gray-600 transition-transform duration-200 ${isExpanded ? 'rotate-90' : ''}`}
    {...props}
  >
    <polyline points="9 18 15 12 9 6"></polyline>
  </svg>
)
export const InfoOrWarningIcon: React.FC<React.SVGProps<SVGSVGElement> & { isAnonymous?: number }> = ({
  isAnonymous = false,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="mr-3 h-5 w-5 flex-shrink-0"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    {...props}
  >
    {isAnonymous ? (
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    ) : (
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
      />
    )}
  </svg>
)

export const LanguageIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="mr-1 h-4 w-4"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
    />
  </svg>
)

export const CheckCircleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    className="ml-2 h-5 w-5 text-blue-500"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
      clipRule="evenodd"
    />
  </svg>
)

export const ConfirmationModal: React.FC<{
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  message: string
}> = ({ isOpen, onClose, onConfirm, title, message }) => {
  return (
    <ControlledModal open={isOpen} onOpenChange={(open) => !open && onClose()} title={title} size="sm" centered>
      <div className="text-center">
        <p className="mb-4 text-gray-600">{message}</p>
        <div className="flex justify-center gap-4">
          <Button buttonStyle={ButtonStyle.logo} onClick={onConfirm}>
            Confirm
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </div>
      </div>
    </ControlledModal>
  )
}
